import { useEffect, useState, type JSX } from "react"
import { useAppSelector } from "../../app/hooks"
// import { Eye, EyeClosed } from "lucide-react"
import { ScrollArea } from "@/components/ui/scroll-area"
import { baseUrl, calculateWPM, decimalToPercent, languages } from "@/lib/utils"
import type { ResultLeaderboardBody } from "@/utils/types"
import { toast } from "sonner"
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  //   TableFooter,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { Dashboard } from "../home/Dashboard"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"

export const Leaderboard = (): JSX.Element | null => {
  const homeSlice = useAppSelector(state => state.home)

  const [results, setResults] = useState<ResultLeaderboardBody[]>([])
  const navigate = useNavigate()

  function fetchLeaderboard() {
    fetch(
      `${baseUrl}/result/top/${homeSlice.foreignLanguage}/${homeSlice.timeMode.toString()}/${homeSlice.strictMode.toString()}`,
    )
      .then(res => res.json())
      .then((data: ResultLeaderboardBody[]) => {
        // const resultsData = data
        setResults(data)
      })
      .catch((err: unknown) => {
        console.error("Error fetching leaderboard:", err)
        toast.error("Could not fetch leaderboard")
      })
  }

  useEffect(() => {
    fetchLeaderboard()
  }, [])

  useEffect(() => {
    fetchLeaderboard()
  }, [homeSlice.foreignLanguage, homeSlice.timeMode, homeSlice.strictMode])

  return (
    <div className="flex flex-col flex-1 gap-5 justify-center items-center">
      <Dashboard />
      <ScrollArea className="bg-gray-800 text-white rounded-xl shadow-md p-4 w-full h-96 max-w-4xl">
        <Table>
          <TableCaption>
            Top 100 results in {languages[homeSlice.foreignLanguage].name} - {homeSlice.timeMode} seconds
          </TableCaption>
          <TableHeader>
            <TableRow>
              <TableHead className="text-white">rank</TableHead>
              <TableHead className="text-white px-6">user</TableHead>
              <TableHead className="text-white">wpm</TableHead>
              <TableHead className="text-white">accuracy</TableHead>
              <TableHead className="text-right text-white">date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {results.map((resultLeaderboardBody, index) => (
              <TableRow key={index}>
                <TableCell className="font-medium">{index + 1}</TableCell>
                <TableCell>
                  <Button
                    variant="ghost"
                    className="cursor-pointer"
                    onClick={() => void navigate(`/user/${resultLeaderboardBody.result.google_id ?? ""}`)}
                  >
                    {resultLeaderboardBody.username}
                  </Button>
                </TableCell>
                <TableCell>
                  {calculateWPM(
                    resultLeaderboardBody.result.time_mode,
                    resultLeaderboardBody.result.char_count,
                    resultLeaderboardBody.result.language,
                    homeSlice.strictMode,
                  )}
                </TableCell>
                <TableCell>{decimalToPercent(resultLeaderboardBody.result.accuracy)}</TableCell>
                <TableCell className="text-right">
                  {new Date(resultLeaderboardBody.result.created_at ?? "").toLocaleDateString("en-GB")}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          {/* <TableFooter>
            <TableRow>
              <TableCell colSpan={3}>Total</TableCell>
              <TableCell className="text-right">$2,500.00</TableCell>
            </TableRow>
          </TableFooter> */}
        </Table>
      </ScrollArea>
    </div>
  )
}
